import { businessUnits } from '../../businessUnitConfig';

import en from './en';
import fr from './fr';
import it from './it';

const dictionaries = { fr, en, it };

export const getTranslation = (businessUnit: string) => {
  const language = businessUnits[businessUnit]?.language ?? 'en';
  const dictionary = dictionaries[language];

  return {
    t: (key: string, params?: Record<any, any>) => {
      let translationKey = key;
      if (params?.count !== undefined) {
        if (params.count === 0) {
          translationKey = `${translationKey}_0`;
        } else if (params.count === 1) {
          translationKey = `${translationKey}_1`;
        } else {
          translationKey = `${translationKey}_other`;
        }
      }

      let translation = translationKey.split('.').reduce((o, i) => o[i], dictionary);

      const placeholders = translation?.match(/\{\{(.*?)}}/g);
      placeholders?.forEach(placeholder => {
        const paramName = placeholder.substring(2, placeholder.length - 2);
        translation = translation.replaceAll(placeholder, params?.[paramName]);
      });
      return translation;
    },
  };
};
